export const environment = {
  production: true,
  apiRoot: "/api",
  saasURL: "",
  stagingHost: "rocketadmin-dev.tail9f8b2.ts.net", // Tailscale host
  version: '0.0.0'
};
